import ReportPlayersList from './report-players.list';

export default {
  list: ReportPlayersList,
};
